/* @jsx h */
import { defineComponent, h } from "vue";
import { PageComponent, useLocalization } from "@lemmonhq/uikit";
import { setTitle } from "@lemmonhq/orders";

export * from "./subpages";

export const ManagerPromotionsPage = defineComponent({
  name: "ManagerPromotionsPage",
  setup() {
    const { t } = useLocalization();
    setTitle("Promotions");
    return () => {
      const subpages = [
        {
          name: t("promotions.nav.promotions"),
          icon: "social_leaderboard",
          href: "/app/manager/loyalty",
        },
        {
          name: t("promotions.nav.customers"),
          icon: "person",
          href: "/app/manager/loyalty/customers",
        },
        // Coins are enabled everywhere (not gated), so the tab shows in every
        // environment, not only staging.
        {
          name: t("promotions.coins.nav"),
          icon: "toll",
          href: "/app/manager/loyalty/coins",
        },
        {
          name: t("promotions.memberships.nav"),
          icon: "card_membership",
          href: "/app/manager/loyalty/memberships",
        },
        {
          name: "Automations",
          icon: "bolt",
          href: "/app/manager/loyalty/automations",
        },
        ...(import.meta.env.VITE_ENV === "staging"
          ? [
              {
                name: t("promotions.nav.campaigns"),
                icon: "campaign",
                href: "/app/manager/loyalty/campaigns",
              },
              {
                name: t("campaigns.studio_list.nav"),
                icon: "forum",
                href: "/app/manager/loyalty/campaign-studio",
              },
              {
                name: "Gift Cards",
                icon: "card_giftcard",
                href: "/app/manager/loyalty/gift-cards",
              },
            ]
          : []),
        {
          name: t("promotions.wallet.nav"),
          icon: "wallet",
          href: "/app/manager/loyalty/wallet",
        },
      ];
      return (
        <PageComponent
          title={t("promotions.nav.page_title")}
          titleIcon="social_leaderboard"
          subpages={subpages}
        />
      );
    };
  },
});
